import * as React from "react";
import DeletePanel from "../../components/CustomDelete/DeletePanel";
import strings from "../../config/localization";
import { useDeleteTemplateMutation } from "../../services/appln";

export default function DeletePersonnelTemplate(props: any): any {
  return (
    <DeletePanel
      deleteMutation={useDeleteTemplateMutation}
      deleteArgs={{ id: props.id }}
      buttonLabel={strings.delete}
      confirmationDialogTitle={strings.deleteTemplateTitle}
      confirmationDialogMsg={strings.deleteTemplateConfirmation}
      errorDialogTitle={strings.deleteTemplateFailedTitle}
      errorDialogMsg={strings.deleteTemplateFailedMsg}
    />
  );
}
